<template>
  <div id="app">
<!--    <div class="loader"></div>-->
    <base-menu />
    <router-view/>
  </div>
</template>

<script>
  import { BaseMenu } from '@/components'
  export default {
    name: 'App',
    components: {
      BaseMenu
    },
    mounted() {
      for (let i = 0; i < 5; i++) {
        CSS.registerProperty({
          name: `--a${i}`,
          syntax: `<angle>`,
          initialValue: '0deg',
          inherits: false
        })
      }
    }
  }
</script>

<style lang="scss">
  $c: #490a3d, #bd1550, #e97f02, #f8ca00, #8a9b0f;
  $d: 39em;

  @mixin bars($c, $w: .5em, $t: 5s) {
    $n: length($c);
    $o: .5*$w;
    $l: ();
    $a: ();

    @for $i from 0 to $n {
      $l: $l,
        linear-gradient(
          var(--a#{$i}),
          transparent calc(50% - #{$o}),
          nth($c, $i + 1) 0 calc(50% + #{$o}),
          transparent 0);
      $a: $a, a#{$i} $t cubic-bezier($i/$n, 0, ($n - $i)/$n, 1) infinite;

      @keyframes a#{$i} {
        to {
          --a#{$i}: .5turn
        }
      }

    }

    background: $l;
    animation: $a;
  }

  .loader {
    border: 1px solid red;
    width: $d; height: $d;
    border-radius: 50%;
    background: black;
    @include bars($c);
  }
</style>
